import React from 'react';

const BlogPost = ({ title, date, children }) => (
  <article className="page post">
    <header className="post-header">
      <h1 className="page-title">{title}</h1>
      <p className="post-date">
        <time dateTime={date.iso}>{date.label}</time>
      </p>
    </header>
    <div className="post-body">{children}</div>
  </article>
);

export default BlogPost;
